import { render, staticRenderFns } from "./ToDoListAssignPrivateDialog.vue?vue&type=template&id=4ded2dbe&scoped=true"
import script from "./ToDoListAssignPrivateDialog.vue?vue&type=script&lang=js"
export * from "./ToDoListAssignPrivateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ded2dbe",
  null
  
)

export default component.exports